import PropArray from "../../../type/propArray"
import useWeakMap from "../../../utils/useWeakMap"
import { isLayer } from "../validator/useLayerIdentity"

const store = useWeakMap()

export const storePathBySource = (source, paths) => {
    if (!(paths instanceof PropArray)) '"paths" is not instanceof PropArray';
    if(store.has(source)) return;
    paths = paths.clone();
    store.set(source, paths);
}

/**
 * 
 * @param {Object} layer 
 * @returns {PropArray |  undefined}
 */
export const useQueryPathBySource = (source) => {
    return store.get(source).clone();
}

export default storePathBySource